import React from 'react';
import cfg from '../config';

const Datenschutz = () => {
  return (
    <div className="container-fluid px-2 px-md-4">

      <div className="mb-4 text-center">
        <h1 className="fw-bold">Datenschutzerklärung</h1>
        <p className="text-muted">Informationen zur Verarbeitung personenbezogener Daten</p>
      </div>

      <div className="accordion" id="datenschutzAccordion">

        <div className="accordion-item">
          <h2 className="accordion-header">
            <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#section1">
              1. Datenschutz auf einen Blick
            </button>
          </h2>
          <div id="section1" className="accordion-collapse collapse show">
            <div className="accordion-body">
              <h6>Allgemeine Hinweise</h6>
              <p>
                Die folgenden Hinweise geben einen einfachen Überblick darüber,
                was mit Ihren personenbezogenen Daten passiert, wenn Sie diese Website besuchen.
              </p>
              <h6>Datenerfassung auf dieser Website</h6>
              <p>Personenbezogene Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können.</p>
              <ul>
                <li>Erhebung durch aktive Eingabe (z. B. Formulare)</li>
                <li>Automatische Erfassung technischer Daten</li>
                <li>Verarbeitung zur Bereitstellung der Website</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="accordion-item">
          <h2 className="accordion-header">
            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#section2">
              2. Hosting & Auftragsverarbeitung
            </button>
          </h2>
          <div id="section2" className="accordion-collapse collapse">
            <div className="accordion-body">
              <p>
                Diese Website wird extern gehostet. Personenbezogene Daten werden
                auf den Servern des Hosters verarbeitet.
              </p>
              <div className="alert alert-secondary">
                <strong>Hosting-Anbieter:</strong><br />
                Webhosting Franken<br />
                Wassermannstraße 32<br />
                96050 Bamberg
              </div>
              <p>Es besteht ein Vertrag zur Auftragsverarbeitung (AVV) gemäß Art. 28 DSGVO.</p>
            </div>
          </div>
        </div>

        <div className="accordion-item">
          <h2 className="accordion-header">
            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#section3">
              3. Verantwortliche Stelle
            </button>
          </h2>
          <div id="section3" className="accordion-collapse collapse">
            <div className="accordion-body">
              <p><strong>{cfg.orgFullName}</strong></p>
              <p>
                {cfg.orgDpoName && <>{cfg.orgDpoName}<br /></>}
                {cfg.orgStreet}<br />
                {cfg.orgPostal} {cfg.orgCity}
              </p>
              <p>
                {cfg.orgPhone && <>📞 {cfg.orgPhone}<br /></>}
                {cfg.orgEmail && <>✉️ {cfg.orgEmail}</>}
              </p>
            </div>
          </div>
        </div>

        <div className="accordion-item">
          <h2 className="accordion-header">
            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#section4">
              4. Rechte der betroffenen Personen
            </button>
          </h2>
          <div id="section4" className="accordion-collapse collapse">
            <div className="accordion-body">
              <ul>
                <li>Recht auf Auskunft</li>
                <li>Recht auf Berichtigung</li>
                <li>Recht auf Löschung</li>
                <li>Recht auf Einschränkung der Verarbeitung</li>
                <li>Recht auf Datenübertragbarkeit</li>
                <li>Widerspruchsrecht</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="accordion-item">
          <h2 className="accordion-header">
            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#section5">
              5. Cookies & technische Dienste
            </button>
          </h2>
          <div id="section5" className="accordion-collapse collapse">
            <div className="accordion-body">
              <p>Diese Website verwendet technisch notwendige Cookies zur Bereitstellung grundlegender Funktionen.</p>
              <p className="text-muted small">
                Eine Nutzung der Website ist auch ohne Analyse- oder Marketing-Cookies möglich.
              </p>
            </div>
          </div>
        </div>

      </div>

      <p className="text-muted small mt-4 text-center">
        Stand: {new Date().getFullYear()} – Diese Datenschutzerklärung gilt für Website und App des Vereins.
      </p>
    </div>
  );
};

export default Datenschutz;
